import {LifecycleManager} from "./_base-lifecycles";
import { initDemoTour } from '../components/demo-tour.js';
import { initDemoSlideFrontEnd, initDemoSlideEditor } from '../components/demo-slide.js';

/**************************************************
 Event Definitions
 **************************************************/
const EVENTS = Object.freeze({
    /**
     * This event is called first thing in the editor and main.js files
     * @type {Symbol<'Initialize'>}
     */
    INIT: Symbol('Initialize'),
    /**
     * This event is called when the document is ready in the editor and main.js files
     * @type {Symbol<'Document Ready'>}
     */
    DOCUMENT_READY:Symbol('Document Ready'),
    /**
     * This event is called on the window `load` event in the editor and main.js files
     * @type {Symbol<'Window Load'>}
     */
    WINDOW_LOAD:Symbol('Window Load')
})


/**************************************************
   Main Lifecycle
 **************************************************/
const MainLifecycleManager = new LifecycleManager();


MainLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, initDemoTour)
    .registerEvent(EVENTS.DOCUMENT_READY, initDemoSlideFrontEnd);



// MainLifecycleManager
//     .registerEvent(EVENTS.WINDOW_LOAD, initializeSlider)



/**************************************************
 Editor Lifecycle
 **************************************************/
const EditorLifecycleManager = new LifecycleManager();

EditorLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, initDemoSlideEditor);



export {
    EVENTS,
    MainLifecycleManager,
    EditorLifecycleManager
}